import { Form } from 'antd';
import ContractInsuranceTypeSelector from '@/components/organisms/contract/ContractInsuranceTypeSelector';
import { useState } from 'react';
import ContractWriteFormTemplate from '@/components/template/contract/ContractWriteFormTemplate';
import { allCases } from '@/components/organisms/contract/ContractDriverLicenseType';
import ContractInsuranceType from '@/components/organisms/contract/ContractInsuranceType';
import NumericInput from '@/components/organisms/common/NumericInput';

type ContractInsuranceProps = {
  // TODO
};

const ContractInsuranceForm = () => {
  const key = 'insurance';
  const [driverLicenseType, setDriverLicenseType] = useState<ContractInsuranceType>();

  return (
    <ContractWriteFormTemplate title="보험정보" name={key}>
      <Form.Item name={[key, 'cdw']} label="자차보험 가입여부">
        <ContractInsuranceTypeSelector defaultSelected={ContractInsuranceType.NONE} onChange={(type) => setDriverLicenseType(type)} />
      </Form.Item>
      <Form.Item name={[key, 'cdwAmount']} label="자차보험 비용">
        <NumericInput decimal placeholder="0" suffix="원" />
      </Form.Item>
    </ContractWriteFormTemplate>
  );
};

export default ContractInsuranceForm;
